import { FC } from 'react';

import { AddressFinderAvailabilityStep } from '@eneco/flows/components';
import { usePlaceholderContent } from '@sitecore/common';
import { HeatPumpLeadFlowAddressStepRendering } from '@sitecore/types/HeatPumpLeadFlowAddressStep';

import { ProductType, OrderType } from '../types/types';

export const AddressStep: FC = () => {
  const { HeatPumpLeadFlowAddressStep: { fields: textualData } = {} } = usePlaceholderContent<{
    HeatPumpLeadFlowAddressStep: HeatPumpLeadFlowAddressStepRendering;
  }>();

  return (
    <AddressFinderAvailabilityStep
      product={ProductType.Heatpump}
      orderType={OrderType.Installation}
      textualData={textualData}
    />
  );
};
